import { render, staticRenderFns } from "./AutogestionLogCrudPage.vue?vue&type=template&id=2d60a78e"
import script from "./AutogestionLogCrudPage.vue?vue&type=script&lang=js"
export * from "./AutogestionLogCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports